import { updateObject } from "../../../../shared";
import {
  globalConstants,
  individualGroupProfileConstants,
} from "../../constants";

const { SUCCESS } = globalConstants;
const {
  GROUP_DETAIL,
  PAGINATED_GROUPS_DATA,
  STORES_BY_GROUP_ID,
  STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING,
} = individualGroupProfileConstants;

const initialState = {
  groupDetails: [],
  allLocations: [],
  collectiveData: {},
  allGroupLocations: [],
  groupDataPagination: {
    size: 10,
    number: -1,
    totalElements: 0,
  },
  storesAvgSentimentAndTransactionRatingData: {},
};

export const individualGroupProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case GROUP_DETAIL + SUCCESS:
      return { ...state, groupDetails: action.data };
    case PAGINATED_GROUPS_DATA + SUCCESS:
      return {
        ...state,
        allLocations: action.data.pageData,
        groupDataPagination: action.data.page,
        collectiveData: action.data.componentData,
      };
    case STORES_BY_GROUP_ID + SUCCESS:
      return {
        ...state,
        allGroupLocations: action.data?.data,
      };
    case STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING + SUCCESS:
      return updateObject(state, {
        storesAvgSentimentAndTransactionRatingData: action.data,
      });
    default:
      return state;
  }
};
